import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';
import { OChannel } from '../../models/loyalty-cluster.model';
import { ListMetadata } from '../../models/list-metadata.model';

@Injectable()
export class LoyaltyClusterOchannelService {

  public baseUrl = '/koncentro-loyalty/cluster';
  public urlLoyalty = '/koncentro-loyalty'
  private cachedFields: Observable<any>;

  constructor(
    private http: HttpClientService
  ) { }

  get(clusterHeadId, oChannelId): Observable<OChannel> {
    return this.http.get(this.baseUrl + '/head/' + clusterHeadId + '/ochannel/' + oChannelId);
  }  
  list(clusterHeadId, offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable <{data: Array<OChannel>, metadata: ListMetadata}> {
    const params: URLSearchParams = new URLSearchParams();
    if ( search ) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    if ( offset !== null ) {
      params.set('offset', offset.toString());
    }
    if ( limit !== null ) {
      params.set('limit', limit.toString());
    }

    //return this.http.getPaged(this.baseUrl + '/head/' + clusterHeadId + '/ochannel?' + params.toString());
    return this.http.getPaged(this.baseUrl + '/cluster_head_ochannel?cluster_head_id='+ clusterHeadId + params.toString());
  }

  //update(clusterHeadId, oChannelId, oChannel: OChannel): Observable<OChannel> {
    update(oChannel: OChannel): Observable<OChannel> {
    //return this.http.put(this.baseUrl + '/head/' + clusterHeadId + '/ochannel/' + oChannelId, oChannel);
    return this.http.put(this.baseUrl + '/cluster_head_ochannel', oChannel);
  }

  //create(clusterHeadId, oChannel: OChannel): Observable<OChannel> {
    create(oChannel: OChannel): Observable<OChannel> {
    //return this.http.post(this.baseUrl + '/head/' + clusterHeadId + '/ochannel/' + oChannel.ochannel_id, oChannel );
    return this.http.post(this.baseUrl + '/cluster_head_ochannel', oChannel );
  }

  //remove(clusterHeadId, oChannelId): Observable<OChannel> {
    remove(oChannelId): Observable<OChannel> {
    //return this.http.delete(this.baseUrl + '/head/' + clusterHeadId + '/ochannel/' + oChannelId);
    return this.http.delete(this.baseUrl + '/cluster_head_ochannel/' + oChannelId);
    
  }
  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.urlLoyalty}/schema/ClusterHeadOchannelDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getOchannelByParamGroup() {
    return this.http.get(`${this.urlLoyalty}/params?param_group=ochannel_show_active`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-cluster-ochannel.service.ts